const Index = () => import(/* webpackChunkName: "order" */ './index.vue');
const List = () => import(/* webpackChunkName: "order" */ './components/List.vue');
const Create = () => import(/* webpackChunkName: "order" */ './components/Create.vue');
const Edit = () => import(/* webpackChunkName: "order" */ './components/Edit.vue');
const Home = () => import(/* webpackChunkName: "order" */ './view/Home.vue');


export default [
  {
    path: '/order',
    name: 'order',
    component: Index,
    redirect: { name: 'order-home' },
    title: 'order',
    children: [      
      {
        path: 'home',
        name: 'order-home',
        component: Home,
      },
      {
        path: 'list',
        name: 'order-list',
        component: List,
      },
      {
        path: 'create',
        name: 'order-create',
        component: Create,
      },
      {
        path: ':id/edit',
        name: 'order-edit',
        component: Edit,
      },    
    ],
  },
]
